import React from 'react';
import { Modal, Form, Input, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { InfoCircleOutlined } from '@ant-design/icons';

const AddCustomerModal = ({ visible, onOk, onCancel, form }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={'Kunde hinzufügen'}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label={'Name'}
          rules={[
            { required: true, message: 'Bitte Kundenname eingeben' }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="billingAddress"
          label={'Rechnungsadresse'}
          rules={[
            { required: true, message: 'Bitte Rechnungsadresse eingeben' }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="contact"
          label={'Kontakt'}
          rules={[
            { required: true, message: 'Bitte Kontakt eingeben' }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="email"

          label={
            <>
              Email
              {/*<Tooltip overlayInnerStyle={{minWidth: "350px"}} title="Für die angegebene Email wird automatisch ein Benutzer angelegt. Es muss eine ungenutzte Email Adresse angegeben werden.">*/}
              {/*  <InfoCircleOutlined style={{marginLeft: 3}}/>*/}
              {/*</Tooltip>*/}
            </>
          }
          rules={[
            {
              required: true,
              type: 'email',
              message: 'Bitte valide Email eingeben'
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="phone"
          label={'Telefon'}
          rules={[
            { required: true, message: 'Bitte Telefonnummer eingeben' }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="sepiooAccount"
          label={'Sepioo Account'}
          rules={[
            { required: true, message: 'Bitte Kontonummmer eingeben' }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="sepiooLocation"
          label={'Sepioo Location'}
          rules={[{ required: true, message: 'Bitte Location eingeben' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="sepiooApiKey"
          label={'API Schlüssel'}
          rules={[{ required: true, message: 'Bitte API Schlüssel eingeben' }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

// Default Props
AddCustomerModal.defaultProps = {
  visible: false,
  onOk: () => {},
  onCancel: () => {}
};

// Prop Types (if not using TypeScript)
AddCustomerModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired
};

export default AddCustomerModal;
